export class ApprovalRuleSaveRequest {
    constructor(public approvalRuleId: number, public oldRuleName: string, public newRuleName: string,
        public userName: string) {

    }
}